const drinks = [
    {
        id:1,
        name: 'Sumo natural',
        price: '2,000'
    },
    {
        id:2,
        name: 'café',
        price: '650'
    },
    {
        id:3,
        name: 'Passion fruit',
        price: '3,000'
    }
];

export default drinks;